import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { LISTING_PAGE_PARAM_TYPE_EDIT } from '../../../../util/urlHelpers';
import { Button, SecondaryButton } from '../../../../components';

import css from './FormButtons.module.css';

const FormButtons = props => {
  const {
    className = null,
    rootClassName = null,
    onGoBackATab,
    formApi,
    submitDisabled,
    submitInProgress,
    saveActionMsg,
    submitReady,
    draftingInProgress,
    disableSubmitButtonOnly = false,
    canPublish = true,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  const location = useLocation();
  const params = useParams();
  const canSaveOnDraft = params.type !== LISTING_PAGE_PARAM_TYPE_EDIT;
  const SaveOnDraft = canPublish ? SecondaryButton : Button;

  return (
    <div className={classes}>
      {!!onGoBackATab && (
        <SecondaryButton className={css.goBackButton} onClick={onGoBackATab} type="button">
          <FormattedMessage id="Global.goBack" />
        </SecondaryButton>
      )}
      {canSaveOnDraft && (
        <SaveOnDraft
          className={css.saveAsDraft}
          inProgress={draftingInProgress}
          disabled={submitDisabled}
          ready={submitReady}
          onClick={() => {
            formApi.change('submitAction', 'saveAsDraft');
            if (!!location.state?.from) {
              formApi.change('navigateTo', location.state);
            }
          }}
        >
          <FormattedMessage id="Global.saveAsDraft" />
        </SaveOnDraft>
      )}
      {canPublish && (
        <Button
          className={css.submitButton}
          type="submit"
          inProgress={submitInProgress}
          disabled={submitDisabled || disableSubmitButtonOnly}
          ready={submitReady}
          onClick={() => {
            formApi.change('submitAction', 'saveAndPublish');
            if (!!location.state?.from) {
              formApi.change('navigateTo', location.state);
            }
          }}
        >
          {saveActionMsg}
        </Button>
      )}
    </div>
  );
};

FormButtons.propTypes = {
  className: string,
  rootClassName: string,
  onGoBackATab: func,
  formApi: object,
  submitInProgress: bool.isRequired,
  submitDisabled: bool.isRequired,
  saveActionMsg: string.isRequired,
  submitReady: bool.isRequired,
  enableSaveAsDraft: bool,
  draftingInProgress: bool,
};

export default FormButtons;
